import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import Select from "react-select";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import "yup-phone";

export default function RegistrationStepTwo({
  data,
  incrementStep,
  decrementStep,
}) {
  const relationshipOpts = [
    { value: "mother", label: "Mother" },
    { value: "father", label: "Father" },
    { value: "sibling", label: "Sibling" },
    { value: "aunt", label: "Aunt" },
    { value: "uncle", label: "Uncle" },
    { value: "cousin", label: "Cousin" },
    { value: "grand-parent", label: "Grand Parent" },
    { value: "babysitter-nanny", label: "BabySitter/Nanny" },
    { value: "other", label: "Other" },
  ];
  const isRelationEmpty = relationshipOpts.find(
    (obj) => obj.value === data.emergencyRelation
  );
  const [selectedRelation] = useState(
    isRelationEmpty
      ? { value: isRelationEmpty.value, label: isRelationEmpty.label }
      : null
  );

  const validationSchema = Yup.object().shape({
    emergencyFirstName: Yup.string().required("Required"),
    emergencyLastName: Yup.string().required("Required"),
    emergencyPhone: Yup.string()
      .matches(/^\d{11}$/, "Only 11 digits allowed")
      .required("Required"),
    emergencyRelation: Yup.string().required("Required"),
    emergencyAddress1: Yup.string().required("Required"),
    emergencyCity: Yup.string().required("Required"),
    emergencyPostcode: Yup.string()
      .required("Required")
      .matches(
        "^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$",
        "Invalid Postcode"
      ),
  });

  return (
    <div className="registration-step-2">
      <h5 className="mb-3">Emergency Info:</h5>
      <Formik
        initialValues={data}
        validationSchema={validationSchema}
        onSubmit={(values) => incrementStep(values)}
      >
        {({ values, setFieldValue, handleChange, handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <div className="d-flex flex-wrap">
              <div className="mb-3 me-md-3 me-0 flex-grow-1">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  name="emergencyFirstName"
                  placeholder="Enter first name"
                  value={values.emergencyFirstName}
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="emergencyFirstName"
                  component="p"
                  className="error-message"
                />
              </div>
              <div className="mb-3 flex-grow-1">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  name="emergencyLastName"
                  placeholder="Enter last name"
                  value={values.emergencyLastName}
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="emergencyLastName"
                  component="p"
                  className="error-message"
                />
              </div>
            </div>
            <div className="d-flex flex-wrap">
              <div className="mb-3 me-md-3 me-0 flex-grow-1">
                <Form.Label>Emergency Phone Number</Form.Label>
                <Form.Control
                  type="tel"
                  name="emergencyPhone"
                  placeholder="Enter phone number"
                  value={values.emergencyPhone}
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="emergencyPhone"
                  component="p"
                  className="error-message"
                />
              </div>
              <div className="mb-3">
                <Form.Label>Relationship with Child</Form.Label>
                <Select
                  name="emergencyRelation"
                  className="select-field"
                  defaultValue={selectedRelation}
                  isSearchable={false}
                  options={relationshipOpts}
                  onChange={(opt) =>
                    setFieldValue("emergencyRelation", opt.value)
                  }
                />
                <ErrorMessage
                  name="emergencyRelation"
                  component="p"
                  className="error-message"
                />
              </div>
            </div>
            <div className="d-flex flex-wrap">
              <div className="mb-3 me-md-3 me-0 flex-grow-1">
                <Form.Label>Street Address Line 1</Form.Label>
                <Form.Control
                  type="text"
                  name="emergencyAddress1"
                  placeholder="Enter street address"
                  value={values.emergencyAddress1}
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="emergencyAddress1"
                  component="p"
                  className="error-message"
                />
              </div>
              <div className="mb-3 flex-grow-1">
                <Form.Label>Street Address Line 2</Form.Label>
                <Form.Control
                  type="text"
                  name="emergencyAddress2"
                  placeholder="Enter street address"
                  value={values.emergencyAddress2}
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="emergencyAddress2"
                  component="p"
                  className="error-message"
                />
              </div>
            </div>
            <div className="d-flex flex-wrap">
              <div className="mb-3 me-md-3 me-0 flex-grow-1">
                <Form.Label>Postcode</Form.Label>
                <Form.Control
                  type="text"
                  name="emergencyPostcode"
                  placeholder="Enter postcode"
                  value={values.emergencyPostcode}
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="emergencyPostcode"
                  component="p"
                  className="error-message"
                />
              </div>
              <div className="mb-3 flex-grow-1">
                <Form.Label>City</Form.Label>
                <Form.Control
                  type="text"
                  name="emergencyCity"
                  placeholder="Enter city"
                  value={values.emergencyCity}
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="emergencyCity"
                  component="p"
                  className="error-message"
                />
              </div>
            </div>
            <div className="d-flex flex-wrap"></div>
            <div className="d-flex justify-content-end">
              <Button
                variant="primary"
                className="me-2"
                type="button"
                onClick={() => decrementStep(values)}
              >
                Back
              </Button>
              <Button variant="primary" type="submit">
                Next
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
